export enum RequirementResult {
	NotChecked = 1,
	Yes = 2,
	No = 3,
}
